import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WithDestroy } from '@lib/shared';
import { first } from 'rxjs/operators';
import { UserService } from '../../../user';
import { PipelineDataResolver } from '../../services/pipeline-data.resolver';

@Component({
  selector: 'app-select-loan',
  templateUrl: './select-loan.component.html',
  styleUrls: ['./select-loan.component.scss']
})
export class SelectLoanComponent extends WithDestroy() implements OnInit, OnDestroy {
  public loans: any[];
  public excludedStagesIds = [];
  public noActiveLoan = false;
  private readonly role = 'Loan Officer';
  public stagesIds = {};
  public fundedPipeline: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private pipelineDataResolverService: PipelineDataResolver,
    private userService: UserService
  ) {
    super();
  }

  ngOnInit() {
    this.excludedStagesIds = this.pipelineDataResolverService.closedLoanStages;
    this.stagesIds = this.pipelineDataResolverService.allStagesWithIds;
    const pipelines = this.pipelineDataResolverService.pipelines || [];
    this.fundedPipeline = pipelines.find((pipeline) => pipeline.name === 'FUNDED');
    this.userService
      .getActiveUser()
      .pipe(first())
      .subscribe((value) => {
        this.loans = value.Loans || this.route.snapshot.data.loans;
        this.noActiveLoan = !this.loans.find((item) => !this.excludedStagesIds.includes(item.CurrentStage?.StageId));
        this.loans.forEach((loan) => {
          loan.stageName = this.pipelineDataResolverService.getStageById(loan.CurrentStage?.StageId).displayName;
          loan.presentInExcludedStage = this.excludedStagesIds.includes(loan.CurrentStage?.StageId);
          loan.statusClass = '';
          switch (loan.CurrentStage.StageId) {
            case this.stagesIds['SUSPENDED']:
              loan.statusClass = 'suspended';
              break;
            case this.stagesIds['ADVERSE']:
              loan.statusClass = 'adverse';
              break;
            case this.stagesIds['BROKER_CHECK_RECEIVED']:
            case this.stagesIds['COMMISSION_PAID']:
            case this.stagesIds['LOAN_FUNDED']:
              loan.statusClass = 'closed';
              break;
          }
        });
      });
  }

  public proceed(loan: any) {
    if (this.excludedStagesIds.includes(loan.CurrentStage.StageId)) {
      return;
    }
    if (loan.appSubmissionDate || loan.inviteType === 'DOCUMENT_ONLY') {
      this.router.navigate(['../' + loan.LoanId + '/tasks'], { relativeTo: this.route });
    } else {
      this.router.navigate(['../' + loan.LoanId], { relativeTo: this.route });
    }
  }

  public createNewLoan() {
    this.router.navigate(['../loan-purpose'], { relativeTo: this.route });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
